import Work1 from '../../assets/projects/jotion.jpg'
import Work2 from '../../assets/projects/threads.jpg'
import Work3 from '../../assets/projects/movix.jpg'
import Work4 from '../../assets/projects/studybud.jpg'



export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "Jotion",
    github: "https://github.com/omkar1304/Jotion-using-NextJS",
    link: "https://jotionnote.vercel.app/"
  },
  {
    id: 2,
    image: Work2,
    title: "Threads",
    github: "https://github.com/omkar1304/Threads-using-NextJS",
    link: "https://threads-connect.vercel.app/"
  },
  {
    id: 3,
    image: Work3,
    title: "Movix",
    github: "https://github.com/omkar1304/Movix-using-React-Django",
    link: "https://movixplay.netlify.app/"
  },
  {
    id: 4,
    image: Work4,
    title: "StudyBud",
    github: "https://github.com/omkar1304/StudyBud-using-Django",
    link: "https://studybudweb.pythonanywhere.com/"
  },

]

export const projectsNav = [
  {
    name: "all"
  },
  {
    name: "web"
  },
  {
    name: "app"
  },
  {
    name: "design"
  },
]